
// FIX: Cast import.meta to any to resolve TypeScript error regarding missing env property on ImportMeta.
const metaEnv = (import.meta as any).env || {};

export const env = {
  API_ENDPOINT_URL: metaEnv.VITE_API_ENDPOINT_URL || 'https://apis.alutechcare.com/admin',
  API_ENDPOINT_KEY: metaEnv.VITE_API_ENDPOINT_KEY || 'dtsztd6Y806Yvta7fsgKO6ioPl0aB3TUVgjraaqe',
  IMAGE_ENDPOINT_URL: metaEnv.VITE_IMAGE_ENDPOINT_URL || 'https://codc5m1dj0.execute-api.ap-southeast-1.amazonaws.com/prod',
  IMAGE_ENDPOINT_KEY: metaEnv.VITE_IMAGE_ENDPOINT_KEY || 'opKHcYVt4N5DXpxMB0llY8qsibiyVNkX3y6gjhXH',
  STAFF_DOMAIN: metaEnv.VITE_STAFF_DOMAIN || '',
  CLIENT_DOMAIN: metaEnv.VITE_CLIENT_DOMAIN || '',
};
